import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";

import Modal from "react-responsive-modal";
import "./SartissModal.scss";

const SARTISS_USER_IDS = new Set([
    422, 6632, 10656, 11873, 18731, 23239, 23240, 23322, 23336, 23352, 23353, 23354, 23355, 23363, 23374, 23376, 23377,
    23385, 23386, 23392, 23398, 23404, 23408, 23411, 23417, 23419, 23422, 23423, 23424, 23427, 23428, 23439, 23450,
    23458, 23459, 23471, 23480, 23481, 23485, 23500, 23502, 23503, 23505, 23510, 23511, 23513, 23556, 23561, 23566,
    23583, 23597, 23612, 23615, 23619, 23624, 23647, 23652, 23664, 23666, 23689, 23699, 23704, 23705, 23811, 23817,
    23829, 23838, 23839, 23847, 23853, 23861, 23863, 23864, 23872, 23875, 23890, 23907, 23908, 23943, 23988, 24036,
    24090, 24111, 24228, 24244, 24302, 24321, 24323, 24349, 24470, 24492, 24563, 24571, 24613, 24672, 24673, 24682,
    24695, 24764, 24782, 24889, 24896, 24985, 25099, 25103, 25135, 25243, 25248, 25379, 25397, 25462, 25527, 25577,
    25608, 25651, 25660, 25679, 25726, 25728, 25736, 25746, 25767, 25768, 25771, 25806, 25834, 25836, 25838, 25839,
    25857, 25870, 25888, 25911, 25913, 25916, 25922, 25964, 25985, 26021, 26022, 26026, 26031, 26033, 26034, 26037,
    26040, 26049, 26051, 26053, 26060, 26063, 26070, 26079, 26082, 26088, 26089, 26095, 26099, 26106, 26107, 26108,
    26111, 26115, 26118, 26119, 26121, 26122, 26124, 26136, 26140, 26141, 26142, 26148, 26157, 26161, 26162, 26163,
    26172, 26189, 26191, 26198, 26201, 26208, 26211, 26213, 26219, 26250, 26259, 26263, 26268, 26291, 26308, 26310,
    26314, 26315, 26333, 26336, 26340, 26341, 26348, 26349, 26357, 26358, 26374, 26377, 26398, 26403, 26407, 26425,
    26436, 26450, 26466, 26482, 26495, 26504, 26505, 26529, 26538, 26549, 26586, 26589, 26603, 26620, 26629, 26642,
    26650, 26674, 26688, 26707, 26745, 26798, 26804, 26808, 26835, 26838, 26842, 26848, 26853, 26854, 26859, 26860,
    26869, 26872, 26878, 26883, 26894, 26896, 26900, 26902, 26931, 26950, 26965, 26966, 26983, 26987, 26991, 26996,
    27010, 27103, 27119, 27131, 27148, 27162, 27163, 27169, 27183, 27217, 27225, 27235, 27256, 27257, 27259, 27284,
    27296, 27344, 27360, 27365, 27366, 27384, 27395, 27403, 27409, 27410, 27421, 27425, 27434, 27458, 27470, 27481,
    27505, 27517, 27521, 27550, 27559, 27579, 27582, 27603, 27604, 27606, 27608, 27609, 27648, 27659, 27664, 27709,
    27720, 27730, 27737, 27738, 27742, 27745, 27776, 27855, 27870, 27893, 27894, 27895, 27896, 27911, 27917, 27919,
    27921, 27965, 27979, 27981, 27997, 27998, 28019, 28038, 28049, 28098, 28114, 28175, 28176, 28181, 28192, 28193,
    28253, 28284, 28298, 29075, 29365, 33206, 34150, 43821, 46483, 46800, 47901, 52834, 54098, 54106, 54163, 54231,
    54235, 54260, 54340, 54395, 54396, 54474, 54487, 54676, 54716, 55150, 55173, 55253, 55275, 55710, 55735, 56100,
    56113, 56148, 56399, 56416, 56436, 56712, 56726, 56765, 56821, 56823, 56828, 56851, 56886, 56923, 57102, 57287,
    57461, 57470, 57536, 57606, 58055, 58283, 58516, 58812, 58824, 59063, 59076, 59212, 59221, 59287, 59300, 59301,
    59366, 59427, 59539, 59580, 59641, 59646, 59681, 59723, 59731, 59900, 59965, 60084, 60113, 60117, 60235, 60237,
    60239, 60240, 60255, 60292, 60340, 60436, 60471, 60571, 60572, 60588, 60608, 60631, 60632, 60634, 60638, 60641,
    60645, 60664, 60696, 60705, 60727, 60769, 60774, 60798, 60802, 60808, 60886, 60893, 60927, 60959, 60963, 61060,
    61083, 61121, 61138, 61164, 61217, 61229, 61236, 61256, 61265, 61278, 61290, 61304, 61314, 61331, 61335, 61337,
    61338, 61340, 61341, 61351, 61412, 61425, 61522, 61524, 61551, 61552, 61554, 61566, 61569, 61581, 61605, 61620,
    61622, 61637, 61658, 61664, 61667, 61669, 61670, 61673, 61679, 61687, 61701, 61703, 61710, 61717, 61724, 61725,
    61726, 61728, 61730, 61731, 61736, 61737, 61741, 61743, 61750, 61758, 61761, 61765, 61766, 61767, 61770, 61772,
    61776, 61784, 61787, 61788, 61791, 61792, 61793, 61800, 61802, 61825, 61826, 61827, 61836, 61840, 61841, 61849,
    61869, 61873, 61877, 61879, 61890, 61897, 61900, 61928, 61939, 61940, 61941, 61942, 61943, 61944, 61948, 61950,
    61959, 61961, 61970, 61975, 61988, 61991, 61994, 61995, 61999, 62000, 62002, 62009, 62022, 62024, 62027, 62037,
    62039, 62046, 62056, 62061, 62078, 62088, 62090, 62102, 62106, 62124, 62132, 62141, 62174, 62200, 62202, 62205,
    62208, 62215, 62216, 62220, 62237, 62244, 62247, 62249, 62255, 62256, 62259, 62262, 62265, 62269, 62273, 62274,
    62284, 62291, 62306, 62315, 62326, 62328, 62337, 62338, 62354, 62383, 62385, 62393, 62398, 62406, 62420, 62423,
    62454, 62495, 62543, 62546, 62680, 62685, 62693, 62694, 62698, 62726, 62730, 62739, 62747, 62762, 62773, 62776,
    62779, 62786, 62806, 62818, 62819, 62828, 62845, 62850, 62854, 62877, 62890, 62909, 62948, 62951, 62958, 62972,
    63005, 63017, 63052, 63073, 63086, 63097, 63118, 63183, 63196, 63221, 63242, 63253, 63279, 63282, 63308, 63321,
    63337, 63352, 63385, 63394, 63396, 63410, 63427, 63434, 63435, 63441, 63447, 63448, 63474, 63476, 63486, 63517,
    63524, 63539, 63542, 63564, 63565, 63588, 63594, 63595, 63605, 63613, 63629, 63635, 63638, 63641, 63655, 63657,
    63658, 63664, 63672, 63682, 63686, 63687, 63688, 63690, 63697, 63705, 63708, 63710, 63711, 63715, 63716, 63718,
    63720, 63721, 63730, 63731, 63732, 63734, 63737, 63739, 63743, 63755, 63756, 63769, 63805, 63822, 63823, 63824,
    63834, 63837, 63845, 63851, 63871, 63875, 63889, 63904, 63928, 63946, 63958, 63984, 64023, 64025, 64027, 64036,
    64046, 64085, 64087, 64097, 64102, 64190, 64213, 65488, 66522, 67121, 79490, 92669, 93768, 93865, 94031, 94124,
    94187, 94673, 94837, 94850, 94889, 94915, 94972, 94975, 95017, 95132, 95138, 95141, 95190, 95393, 95463, 95554,
    95569, 95656, 95676, 95768, 95804, 95834, 95897, 96027, 96050, 96138, 96167, 96200, 96263, 96381, 96539, 96592,
    96654, 96691, 96693, 96699, 96708, 96731, 96799, 96863, 97075, 97156, 97202, 97204, 97205, 97230, 97337, 97444,
    97585, 97588, 97599, 97742, 97853, 97904, 97956, 97958, 97960, 97964, 98069, 98082, 98136, 98151, 98190, 98302,
    98342, 98369, 98382, 98384, 98387, 98468, 98562, 98569, 98597, 98612, 98667, 98674, 98705, 98745, 98748, 98755,
    98822, 98831, 98850, 98851, 98854, 98883, 98888, 98890, 98903, 98917, 98920, 98924, 98928, 98931, 98932, 98933,
    98940, 98942, 98944, 98945, 98946, 98947, 98948, 98949, 98955, 98964, 98975, 98979, 98983, 98988, 98989, 98993,
    98996, 99006, 99016, 99018, 99065, 99074, 99092, 99094, 99095, 99097, 99110, 99111, 99125, 99140, 99145, 99159,
    99170, 99174, 99183, 99184, 99222, 99223, 99224, 99226, 99261, 99345, 99379, 99383, 99394, 99405, 99406, 99429,
    99444, 99472, 99481, 99490, 99522, 99554, 99647, 99677, 99749, 99777, 99789, 99799, 99860, 99884, 100015, 100040,
    100043, 100089, 100201, 100261, 100262, 100267, 100275, 100291, 100300, 100308, 100321, 100324, 100375, 100385,
    100421, 100422, 100430, 100436, 100438, 100447, 100450, 100452, 100454, 100475, 100477, 100483, 100488, 100514,
    100515, 100560, 100567, 100572, 100575, 100594, 100607, 100632, 100659, 100661, 100662, 100680, 100683, 100686,
    100695, 100700, 100709, 100715, 100720, 100727, 100729, 100733, 100755, 100762, 100770, 100796, 100814, 100823,
    100830, 100831, 100834, 100835, 100849, 100851, 100852, 100854, 100862, 100865, 100882, 100891, 100892, 100893,
    100899, 100902, 100904, 100907, 100909, 100915, 100916, 100917, 100918, 100919, 100923, 100926, 100928, 100929,
    100930, 100931, 100932, 100935, 100937, 100946, 100958, 100960, 100970, 100972, 100976, 100979, 100993, 100996,
    101000, 101004, 101006, 101008, 101012, 101018, 101021, 101039, 101045, 101056, 101068, 101100, 101101, 101102,
    101103, 101104, 101105, 101106, 101108, 101109, 101110, 101111, 101112, 101113, 101114, 101115, 101116, 101117,
    101119, 101137, 101142, 101144, 101145, 101155, 101156, 101157, 101158, 101172, 101191, 101192, 101193, 101194,
    101203, 101207, 101209, 101220, 101221, 101223, 101231, 101234, 101242, 101244, 101248, 101257, 101261, 101275,
    101282, 101294, 101308, 101310, 101316, 101317, 101319, 101321, 101325, 101344, 101360, 101362, 101363, 101364,
    101367, 101368, 101370, 101371, 101372, 101376, 101379, 101385, 101387, 101388, 101400, 101401, 101407, 101408,
    101411, 101422, 101428, 101430, 101431, 101432, 101438, 101446, 101455, 101456, 101459, 101462, 101474, 101479,
    101482, 101483, 101484, 101491, 101492, 101495, 101498, 101499, 101500, 101503, 101508, 101510, 101512, 101513,
    101514, 101515, 101517, 101525, 101545, 101547, 101550, 101558, 101563, 101582, 101586, 101596, 101610, 101613,
    101616, 102838, 102947, 108110, 109651,
]);

const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.creative.ality.events";
const IOS_STORE_URL = "https://apps.apple.com/ro/app/ality-business-events/id6756013017";

export default function SartissModal() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            console.log("Checking whether to show Sartiss modal...");

            // Don't show on the business/events app
            if (process.env.REACT_APP_TYPE === "events") {
                console.log("Not showing Sartiss modal because we're in the events app");
                return;
            }

            // User must be logged in
            const jwt = localStorage.getItem("jwt");
            if (!jwt) {
                console.log("Not showing Sartiss modal because user is not logged in");
                return;
            }

            // Check if user ID is in the target list
            const userId = Number(localStorage.getItem("id"));
            if (!userId || !SARTISS_USER_IDS.has(userId)) {
                console.log("Not showing Sartiss modal because user ID is not in the target list");
                return;
            }

            console.log("Showing Sartiss modal!");

            setVisible(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        setVisible(false);
    };

    const openLink = (link) => {
        if (window.flutter_inappwebview) {
            window.flutter_inappwebview.callHandler("openLink", link);
        } else if (window.alityAppView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    action: "openLink",
                    url: link,
                }),
            );
        } else {
            window.open(link, "_blank");
        }
    };

    return (
        <Modal
            classNames={{
                overlay: "modal-overlay",
                modal: "modal-profile sartiss-modal",
                closeButton: "modal-close-button",
            }}
            styles={{
                overlay: { zIndex: "1000000000000000" },
            }}
            open={visible}
            onClose={handleClose}
            focusTrapped={false}
        >
            <div className="sartiss-modal-content">
                <img src={logo} className="sartiss-logo" alt="Ality" />

                <div className="sartiss-badge">Conferință</div>

                <h5 className="sartiss-title">Conferința Sartiss 2026</h5>

                <p className="sartiss-text">
                    Pentru a participa la <strong>Conferința Sartiss 2026</strong> descarcă-o acum!
                </p>

                <p className="sartiss-subtext">
                    Găsește toate detaliile evenimentului, programul complet și networking-ul direct în aplicația Ality
                    Business Events.
                </p>

                <div className="sartiss-buttons">
                    <div className="sartiss-btn sartiss-btn-android" onClick={() => openLink(ANDROID_STORE_URL)}>
                        <svg className="sartiss-btn-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302-2.302 2.302-2.652-2.302 2.652-2.302zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                        </svg>
                        <span className="sartiss-btn-label">
                            <span className="sartiss-btn-small">Descarcă de pe</span>
                            <span className="sartiss-btn-store">Google Play</span>
                        </span>
                    </div>

                    <div className="sartiss-btn sartiss-btn-ios" onClick={() => openLink(IOS_STORE_URL)}>
                        <svg className="sartiss-btn-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                        </svg>
                        <span className="sartiss-btn-label">
                            <span className="sartiss-btn-small">Descarcă de pe</span>
                            <span className="sartiss-btn-store">App Store</span>
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
